import eBillRoutes from '@/routes/chile/routes/eBillRoutes';
import approvalRoutes from '@/routes/chile/routes/approvalRoutes';
import aduanasRoutes from '@/routes/chile/routes/aduanasRoutes';
import toolsRoutes from '@/routes/chile/routes/toolsRoutes';
import operationsRoutes from '@/routes/chile/routes/operationRoutes';
import dntRoutes from '@/routes/chile/routes/dntRoutes';
import documentManagementRoutes from '@/routes/chile/routes/documentManagementRoutes';
import templateRoutes from '@/routes/chile/routes/templateRoutes';
import receiptsRoutes from '@/routes/chile/routes/receiptsRoutes';
import materialsRequestsRoutes from '@/routes/chile/routes/materialsRequestsRoutes';
import billingRoutes from '@/routes/chile/routes/billingRoutes';

export default [
  ...eBillRoutes,
  ...approvalRoutes,
  ...aduanasRoutes,
  ...toolsRoutes,
  ...operationsRoutes,
  ...dntRoutes,
  ...documentManagementRoutes,
  ...templateRoutes,
  ...receiptsRoutes,
  ...materialsRequestsRoutes,
  ...billingRoutes
];
